import styled, {css} from 'styled-components';

export default styled.div`
	display: grid;
	flex: 1;
	grid-template-columns: 1fr var(--px-150) var(--px-120);
	grid-template-areas: 'name engagements contacts';
	align-items: center;
	gap: var(--spacing-medium);

	&.with-menu {
		grid-template-columns: 1fr var(--px-150) var(--px-120) var(--px-32);
		grid-template-areas: 'name engagements contacts menu';
	}

	.name {
		grid-area: name;
	}

	.engagements {
		grid-area: engagements;
	}

	.contacts {
		grid-area: contacts;
	}

	.menu {
		grid-area: menu;
	}
`;
